import { useLayer } from '../../shell/layer-stack';
import { useLanguage } from '../../shell/language-context';
import { brandAssets } from '../../theme/brand-assets';

// The check-in code overlay (customer gap §A.3 H7; Home.dc.html L238-246): a full-screen
// scrim with a white plate — the booking QR, its code, "Check-in code". The design draws
// the brand mark as a stand-in; this shows the server-rendered QR (GET /bookings/{code}/qr,
// API-43 — it encodes only the code), falling back to the mark while it loads. Any tap,
// Esc or Back closes it (layer stack, CB-17).
export function HomeQrOverlay({
  code,
  qrSrc,
  onClose,
}: {
  code: string | null;
  qrSrc: string | null;
  onClose: () => void;
}) {
  const { t } = useLanguage();
  const { z } = useLayer(Boolean(code), onClose, { kind: 'sheet' });
  if (!code) return null;
  return (
    <div className="hm-qr" data-motion="" style={{ zIndex: z }} onClick={onClose}>
      <button
        type="button"
        className="hm-qr__plate"
        aria-label={t('action.close')}
        onClick={onClose}
      >
        <img className="hm-qr__img" src={qrSrc ?? brandAssets.mark} alt={t('user.home.hero.qr')} />
        <span className="hm-qr__code">{code}</span>
        <span className="hm-qr__label">{t('user.home.hero.qr')}</span>
      </button>
    </div>
  );
}
